
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";

const CourseNotFound = () => {
  return (
    <div className="text-center py-12">
      <div className="flex justify-center mb-6">
        <AlertCircle className="h-16 w-16 text-orange-500" />
      </div>
      <h2 className="text-2xl font-semibold mb-4">Course not found</h2>
      <p className="text-gray-600 mb-3">The course you're looking for doesn't exist or has been removed.</p>
      <p className="text-gray-600 mb-6">Please check the URL and try again, or browse our available courses.</p>
      <Link to="/courses">
        <Button className="bg-[#34BC56] hover:bg-[#2ba349]">Browse courses</Button>
      </Link>
    </div>
  );
};

export default CourseNotFound;
